import type { Membership, MeResponse } from "@family/shared";
import { getFamilySlugForHost } from "../lib/families";

/**
 * Given a MeResponse, returns the membership matching the current domain.
 * Falls back to the first membership if the domain isn't mapped (e.g. localhost).
 */
export function resolveMembership(
  data: MeResponse | undefined,
): Membership | undefined {
  if (!data || data.memberships.length === 0) return undefined;

  const domainSlug = getFamilySlugForHost();
  if (domainSlug) {
    return data.memberships.find((m) => m.familySlug === domainSlug);
  }

  // Fallback for localhost / unknown domains: first membership
  return data.memberships[0];
}
